import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Cookie, MessageCircle } from "lucide-react";
import { Link } from "react-router-dom";
import { useLang } from "@/lib/i18n";

export const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

export const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) {
    return <div className="min-h-[60vh] bg-obsidian" />;
  }
  if (!user) {
    return <Navigate to="/inloggen" state={{ next: location.pathname }} replace />;
  }
  return children;
};

export const AdminRoute = ({ children }) => {
  const { user } = useAuth();
  if (user === null) {
    return <div className="min-h-[60vh] bg-obsidian" />;
  }
  if (!user || user.role !== "admin") {
    return <Navigate to="/inloggen" replace />;
  }
  return children;
};

export const CookieBanner = () => {
  const [choice, setChoice] = useState(() => localStorage.getItem("deo_cookies"));
  if (choice) return null;
  const decide = (v) => {
    localStorage.setItem("deo_cookies", v);
    setChoice(v);
  };
  return (
    <div data-testid="cookie-banner" className="fixed bottom-4 left-4 right-4 sm:right-auto sm:max-w-md z-[120] border border-gold/25 bg-elevate/95 backdrop-blur-md p-5 shadow-[0_30px_60px_-20px_rgba(0,0,0,0.9)]">
      <div className="flex items-start gap-3">
        <Cookie size={18} className="text-gold mt-0.5 shrink-0" />
        <div>
          <p className="text-sm text-cream leading-relaxed">
            Wij gebruiken alleen functionele en anonieme cookies om jouw ervaring te verbeteren.{" "}
            <Link to="/cookies" className="text-gold underline underline-offset-2">Cookiebeleid</Link>
          </p>
          <div className="mt-4 flex gap-3">
            <button data-testid="cookie-accept" onClick={() => decide("accepted")} className="bg-gold text-obsidian font-mono text-[10px] tracking-[0.25em] uppercase px-5 py-2.5">Akkoord</button>
            <button data-testid="cookie-decline" onClick={() => decide("declined")} className="border border-cream/25 text-mist font-mono text-[10px] tracking-[0.25em] uppercase px-5 py-2.5 hover:text-cream">Weigeren</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export const WhatsAppFloat = () => {
  const { t } = useLang();
  return (
  <a
    data-testid="whatsapp-support-button"
    href="https://wa.me/319999999999?text=Hallo%20DEO%20ATELIER%2C%20ik%20heb%20een%20vraag"
    target="_blank"
    rel="noreferrer"
    aria-label={t("misc.waAria")}
    className="fixed bottom-5 right-5 z-[110] flex h-13 w-13 items-center justify-center rounded-full bg-emerald-500 hover:bg-emerald-400 text-white shadow-[0_20px_40px_-10px_rgba(16,185,129,0.5)] transition-transform hover:-translate-y-1 p-3.5"
  >
    <MessageCircle size={22} />
  </a>
  );
};
